<script lang="ts">
	import MetadataList from '#lib/MetadataList.svelte';
	import { t } from '#lib/i18n/tranlsator.svelte.ts';
	import type { IfgRequestSource } from '#src/types/sources.ts';

	interface Props {
		source: IfgRequestSource;
	}
	let { source }: Props = $props();

	const metadata = $derived.by(() => {
		const m: Record<string, unknown> = {};
		if (source.status) {
			m[t('sources.foi.status')] = source.status;
		}
		if (source.resolution) {
			m[t('sources.foi.resolution')] = source.resolution;
		}
		if (source.refusal_reason) {
			m[t('sources.foi.refusalReason')] = source.refusal_reason;
		}
		if (source.public_body) {
			m[t('sources.foi.authority')] = source.public_body;
		}
		if (source.jurisdiction) {
			m[t('sources.foi.jurisdiction')] = source.jurisdiction;
		}
		if (source.created_at) {
			m[t('sources.foi.filed')] = source.created_at;
		}
		if (source.due_date) {
			m[t('sources.foi.dueDate')] = source.due_date;
		}
		if (source.last_message) {
			m[t('sources.foi.lastMessage')] = source.last_message;
		}
		if (source.costs) {
			m[t('sources.foi.costs')] = `€${source.costs.toLocaleString()}`;
		}
		return m;
	});
</script>

{#if source.description}
	<div class="section">
		<p class="description">{source.description}</p>
	</div>
{/if}

{#if Object.keys(metadata).length}
	<div class="section">
		<MetadataList {metadata} />
	</div>
{/if}

{#if source.tags?.length}
	<div class="section">
		<div class="tags">
			{#each source.tags as tag (tag)}
				<span class="tag">{tag}</span>
			{/each}
		</div>
	</div>
{/if}

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.section {
		@include lib.flex-column();
		gap: 0.5rem;

		.description {
			font-size: 0.875rem;
			color: var(--text-secondary);
			margin: 0;
			line-height: 1.5;
			white-space: pre-line;
		}

		.tags {
			@include lib.flex-row();
			flex-wrap: wrap;
			gap: 0.25rem;

			.tag {
				font-size: 0.75rem;
				padding: 0.125rem 0.5rem;
				border-radius: 999px;
				background: var(--surface-3);
			}
		}
	}
</style>
